var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.999 25.316c-.085 0-8.578-.006-10.685-.576a3.44 3.44 0 01-2.42-2.434 36.382 36.382 0 01-.57-6.626 36.355 36.355 0 01.57-6.625 3.443 3.443 0 012.42-2.436c2.107-.568 10.6-.574 10.685-.574.085 0 8.58.006 10.687.574a3.431 3.431 0 012.418 2.436c.394 2.186.585 4.404.572 6.625a36.138 36.138 0 01-.572 6.625 3.427 3.427 0 01-2.418 2.434c-2.111.57-10.602.577-10.687.577zm-2.8-13.704v8.135l7.15-4.067-7.15-4.068z",
    fill: "#D9D9D9"
  })));
}
export default __webpack_public_path__ + "assets/static/media/youtube.06034534.svg";
export { SvgYoutube as ReactComponent };